__turbopack_context__.v({
  "bottom": "styles-module-scss-module__qaum4G__bottom",
  "bottom__center": "styles-module-scss-module__qaum4G__bottom__center",
  "bottom__left": "styles-module-scss-module__qaum4G__bottom__left",
  "bottom__right": "styles-module-scss-module__qaum4G__bottom__right",
  "button": "styles-module-scss-module__qaum4G__button",
  "footer": "styles-module-scss-module__qaum4G__footer",
  "inner": "styles-module-scss-module__qaum4G__inner",
  "legal": "styles-module-scss-module__qaum4G__legal",
  "logo": "styles-module-scss-module__qaum4G__logo",
  "logo__description": "styles-module-scss-module__qaum4G__logo__description",
  "logo__sign": "styles-module-scss-module__qaum4G__logo__sign",
  "logo__sub": "styles-module-scss-module__qaum4G__logo__sub",
  "logo__text": "styles-module-scss-module__qaum4G__logo__text",
  "nav": "styles-module-scss-module__qaum4G__nav",
  "social": "styles-module-scss-module__qaum4G__social",
  "top": "styles-module-scss-module__qaum4G__top",
});
